import { render, staticRenderFns } from "./UserCenter.vue?vue&type=template&id=06464904&scoped=true&"
import script from "./UserCenter.vue?vue&type=script&lang=js&"
export * from "./UserCenter.vue?vue&type=script&lang=js&"
import style0 from "./UserCenter.vue?vue&type=style&index=0&id=06464904&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06464904",
  null
  
)

export default component.exports